import ConsultShoppingByFamily from './Containers/Consult';

export default ConsultShoppingByFamily;
